import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
@Injectable({
  providedIn: 'root'
})
export class AppsettingsService {

  isAuthenticate: boolean = false;
  private endpoint = environment.endpoint;
  private url = this.endpoint;
  private urlCarga = environment.cargaendpoint

  constructor(private httpclient: HttpClient,
    private router: Router
    ) { }

  getNewAppSettings(groupId, token) {
    // // // console.log("token",token );

    let url_env = (environment["type"] === 'stg' || environment["type"] === 'prod') ? this.urlCarga+'/v1.0' : this.urlCarga
    const url = url_env + '/custom-ecarga/settings/groups/' + groupId
    // // // console.log("withoutv1", url);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'x-api-key': environment.apiKey,
        'Authorization': 'Bearer ' + token,
      })
    };

    return new Promise(resolve => {
      this.httpclient.get(url, httpOptions)
      .subscribe(async response => {
          let res;
          res = response; 
          
          res.insurances = response['data'].insurance.sort(
            (a, b) => +a.premium - +b.premium
          );
  
          res.fees = response['data'].fees.sort((a, b) => +a.sort - +b.sort);
  
          res.helpers =response['data'].helper.sort(
            (a, b) => +a.sort - +b.sort
          );
  
          res.packageTypes = response['data'].packageType
            .sort((a, b) => +a.sort - +b.sort)
            .filter((t) => t.display);
  
            res.locations = response['data'].location;
  
          let enabledTruckTypes = response['data'].truckType.filter(
            (t) => t.truckStatus == "enabled"
          );
  
          res.truckTypes = enabledTruckTypes
            .sort((a, b) => +a.sort - +b.sort)
            .filter((t) => t.displayName);
  
            res.custom = res.data;

          await localStorage.setItem("appSettings", JSON.stringify(res));
          resolve(true)
        },
        err => {
          console.log("appsettings",err)
          if(err.status === 0){
            this.isAuthenticate = false
            this.router.navigate(['/login'])
          }
          resolve(false)
        }
      );

    }).catch(err => {
      // // console.log(err)
    })
  }
}
